import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ContentfulService } from '../contentful.service';
import { CreditIncreaseService } from '../credit-increase.service';
@Component({
  selector: 'app-collapse',
  standalone: true,
  imports: [],
  templateUrl: './collapse.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './collapse.component.scss',
})
export class CollapseComponent implements OnInit {
  constructor(
    readonly contentfulService: ContentfulService,
    readonly creditIncreaseService: CreditIncreaseService
  ) {}
  page_content: any;
  contentfulData: any;
  currentYear: any;
  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    this.creditIncreaseService.enLanguage.subscribe((res: any) => {
      this.getContentfulData(res ? 'en' : 'fr');
    });
  }
  getContentfulData(currentLang: any) {
    this.contentfulService
      .getEntry(currentLang, 'legalDisclaimer', {
        'fields.name': 'LegalDisclaimerCLI',
        include: 10,
      })
      .then((res: any) => {
        this.page_content = res;
        
        
      });
  }
}
